
export * from '../../map-google-maps/__liferay__/index.js';
